import { useIntl } from 'react-intl';

import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import useAuth from 'src/hooks/useAuth';
import Content from 'src/componentes/pages/content';
import Edit from './edit';
import SearchSchema from './SearchSchema';
import Search from './search';
import { capitalizeFirstLetter } from 'src/utils/string';

const MovimentacaoFinanceiraList = ({ convenioId, contratoId, projetoId }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  let filtroId = 80;
  let tag = 2020;

  if (convenioId) {
    filtroId = 83;
    tag = 2023;
  } else if (contratoId) {
    filtroId = 85;
    tag = 2025;
  } else if (projetoId) {
    filtroId = 86;
    tag = 2026;
  }

  const ehTelaGerenciar = !convenioId && !contratoId && !projetoId;

  return (
    <Content
      showBackButton={ehTelaGerenciar}
      titulo={
        ehTelaGerenciar
          ? intl.formatMessage({ id: 'movimentacaoFinanceira' })
          : ''
      }
    >
      <List
        url="/MovimentacaoFinanceira"
        editComponent={Edit}
        showExport={ehTelaGerenciar}
        showSearch={ehTelaGerenciar}
        showNew={ehTelaGerenciar}
        showEdit={ehTelaGerenciar}
        showDelete={ehTelaGerenciar}
        searchSchema={SearchSchema}
        showMenu={ehTelaGerenciar}
        searchComponent={<Search />}
        filtroId={filtroId}
        tag={tag}
        parameters={{
          convenioId: convenioId,
          contratoId: contratoId,
          projetoId: projetoId,
        }}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'convenio' })}
          valueField="convenio"
          default
          visible={ehTelaGerenciar || convenioId != null}
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'convenente' })}
          valueField="convenente"
          default
          visible={ehTelaGerenciar || convenioId != null}
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'contrato' })}
          valueField="contrato"
          default
          visible={ehTelaGerenciar || convenioId != null || contratoId != null}
        />
        <ListColumn
          headerText={capitalizeFirstLetter(resources.projeto)}
          valueField="projeto"
          default
          visible={ehTelaGerenciar || projetoId != null}
        />
        <ListColumn
          headerText={capitalizeFirstLetter(resources.planodecontas)}
          valueField="planoContas"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'tipo' })}
          valueField="tipo"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'entidade' })}
          valueField="entidade"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'label.dataPrevista' })}
          valueField="dataPrevista"
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'label.dataRealizada' })}
          valueField="dataRealizada"
          required
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'valor' })}
          valueField="valor"
          required
          default
        />
      </List>
    </Content>
  );
};

export default MovimentacaoFinanceiraList;
